export default __webpack_public_path__ + "static/media/vitalik_nft_11.b926c3ae.svg";